<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-switch-complete`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.981 8H21.997v21h18v-7.994h4V31a2 2 0 01-1.85 1.995l-.15.005h-22a2 2 0 01-1.994-1.85l-.006-.15V6a2 2 0 011.85-1.995l.15-.005h14.984v4zM9.6 26.867a.999.999 0 01.2.2l4 5.333A1 1 0 0113 34h-1.75a8.004 8.004 0 007.482 5.996l.265.004h8a1 1 0 01.994.883l.006.117v2a1 1 0 01-.883.993l-.117.007h-8c-5.945 0-10.881-4.324-11.834-10H5a1 1 0 01-.8-1.6l4-5.333a1 1 0 011.4-.2zM42.678 11.12l-1.414-1.414a1 1 0 00-1.415 0l-7.778 7.778-3.535-3.535a1 1 0 00-1.415 0l-1.414 1.414a1 1 0 000 1.414l5.657 5.657a1 1 0 001.414 0l9.9-9.9a1 1 0 000-1.414z"/></svg>
</template>
<script>

export default {
  name: 'IconSwitchComplete',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
